import script from "./text-with-image.vue?vue&type=script&setup=true&lang=js"
export * from "./text-with-image.vue?vue&type=script&setup=true&lang=js"

import "./text-with-image.vue?vue&type=style&index=0&id=364f0266&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-364f0266"]])

export default __exports__